import {useAuthContext, useClient, APIClient} from '../context/auth-context';
import {useQuery, useMutation} from 'react-query';
import {toast} from 'react-toastify';

export type Location = {
  locationName: string;
  address: string;
  location: {
    latitude?: number;
    longitude?: number;
  };
  ipAddresses?: string[];
};
export type CheckInSettingModel = {
  enableFacePass: boolean;
  enableGPSCheckIn: boolean;
  checkInGeoLocations?: Location[];
};

export function getLocation(client: APIClient, address: string) {
  return client.get<{data: {longitude: string; latitude: string}}>(
    `attendance/location/info?Address=${encodeURIComponent(address)}`,
  );
}

function save(client: APIClient, companyId: string, data: CheckInSettingModel) {
  return client.put(`attendance/company/${companyId}/checkin/setting`, {
    data: {
      ...data,
      checkInGeoLocations: data.enableGPSCheckIn
        ? data.checkInGeoLocations
        : [],
    },
  });
}

function confirm(client: APIClient, companyId: string) {
  return client.put(`attendance/company/${companyId}/checkin/setting/confirm`);
}
export function useSaveSetting(actions: any) {
  const client = useClient();
  const {companyId} = useAuthContext();
  return useMutation(
    (data: CheckInSettingModel) => save(client, companyId, data),
    {
      ...actions,
      onError: (error: {code: number; message: string}) => {
        if (error.code !== 500) {
          toast.error(error.message || '打卡設定儲存失敗', {
            hideProgressBar: true,
            position: 'top-center',
            autoClose: false
          });
        }
      },
    },
  );
}

export function useConfirmSetting(actions: any) {
  const client = useClient();
  const {companyId} = useAuthContext();
  return useMutation(
    (data: CheckInSettingModel) =>
      save(client, companyId, data).then(() => confirm(client, companyId)),
    {
      ...actions,
      onError: (error: {code: number; message: string}) => {
        if (error.code !== 500) {
          toast.error(error.message || '打卡設定儲存失敗', {
            hideProgressBar: true,
            position: 'top-center',
            autoClose: false
          });
        }
      },
    },
  );
}
